import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { memberInfoSelector } from '@doda/common/src/redux/features/memberInfo';
import {
  prefNameSelector,
  prefOnlySelectJobCountSelector,
} from '@doda/common/src/redux/features/prefOnlyFlgSlice';
import { queryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { createUrl } from '@doda/common/src/utils/urlUtil';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { isCanonical } from '@doda/common/src/utils/seoUtil';
import { useRouter } from 'next/router';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';
import { ToggleTag } from '@doda/io-react/common';
import { PRE_ONLY_FLG_PARAM } from '../../constants';

/**
 * 都道府県のみで募集中ボタン
 * @returns
 */
export const PrefOnlyButton = () => {
  const prefName = useAppSelector(prefNameSelector);
  const prefJobCount = useAppSelector(prefOnlySelectJobCountSelector);
  const loginStatus = useAppSelector(memberInfoSelector)?.loginStatus
    ? 'login'
    : 'logout';
  const queryParams = useAppSelector(queryParamsSelector);
  const { pf } = queryParams;
  const route = useRouter().asPath;
  const isStaticUrl = isCanonical(route);

  // pfが1の場合は選択中
  const isSelected = pf === '1';

  const usrclk_searchList = `PC-${loginStatus}JobSearchList_searchResultHeaderArea_setSearchCondition_${isSelected ? PRE_ONLY_FLG_PARAM.ALL : PRE_ONLY_FLG_PARAM.RECRUITING_ONLY_IN_SET_LOC}`;

  const onClick = () => {
    if (isStaticUrl) {
      const staticUrl = makeStaticUrl(
        {
          ...queryParams,
          [QUERY_PARAMS.pf]: undefined,
          [QUERY_PARAMS.usrclk_searchList]: undefined,
        },
        DODA_SITE_URL.jobSearchList
      );

      const url = createUrl({
        href: staticUrl,
        params: {
          pf: isSelected ? '0' : '1',
          usrclk_searchList,
        },
      });

      window.location.href = url;
    } else {
      const url = createUrl({
        href: DODA_SITE_URL.jobSearchList,
        params: {
          ...queryParams,
          pf: isSelected ? '0' : '1',
          usrclk_searchList,
        },
      });

      window.location.href = url;
    }
  };

  return (
    <ToggleTag
      selected={isSelected}
      text={`${prefName}のみで募集中`}
      count={prefJobCount}
      onClick={onClick}
    />
  );
};
